String.prototype.capitalize = function() {
    let comps = this.split(' ').map(comp => comp.charAt(0).toUpperCase() + comp.slice(1));
    return comps.join(' ');
}
String.prototype.initials = function() {
    let tokens  = this.split(' ');
    return tokens.map(item => item.length > 0 ? item[0].toUpperCase() : '').slice(0, 2).join(' ');
}